import React from 'react'
import baseStyles from './Base.module.css'
import PageStatus from '../PageStatus'
import { isHeg, isTicEeTp, isTinTpEe, isTicTinEcgPt, isComemPt, isComemEeTp } from '../lib/utils'
import { applyTo, cond, always, T } from 'ramda'
import Student from '../Student'

export default ({ path }) => {
    const { student } = Student.useContainer()
    return (
        <div className={baseStyles.root}>
            <h2>Horaire des cours</h2>
            <PageStatus path={path} />
            {applyTo(
                student,
                cond([
                    [
                        isHeg,
                        always(
                            <>
                                <p>La présence aux cours est obligatoire.</p>
                                <p>
                                    Votre classe, ainsi que votre horaire vous sera communiqué par email, sur votre
                                    adresse email de l’École.
                                </p>
                                <p>Pour les <strong>étudiant·es en emploi</strong>, les <a
                                    href="https://intra.heig-vd.ch/departement/departement-heg/filiere/administration-filiere/horaires-et-inscriptions/Documents/Jours%20de%20cours%20%C3%A9tudiants%20EE.pdf"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    jours de cours
                                </a> en première année sont :</p>
                                <ul>
                                    <li>Lundi après-midi et soir</li>
                                    <li>Mercredi matin et après-midi</li>
                                    <li>Samedi matin</li>
                                </ul>
                            </>
                        ),
                    ],
                    [
                        isTinTpEe,
                        always(
                            <>
                                <p>Les jours de cours des 1ères années à temps partiel ou en emploi seront les <strong>lundi, mardi et vendredi</strong>. Les jours de cours peuvent être différents les années suivantes.</p>
                                <p>Vous trouverez votre horaire personnalisé, <strong>début septembre</strong> uniquement, sous le lien: <a href="https://gaps.heig-vd.ch/consultation/horaires">https://gaps.heig-vd.ch/consultation/horaires</a>. Si l’horaire ne s’affiche pas, sélectionner « S1 26-27 ».</p>
                            </>
                        ),
                    ],
                    [
                        isTicTinEcgPt,
                        always(
                            <>
                                <p>La formation à plein temps demande une disponibilité complète sur la semaine. Elle se déroule sur 6 semestres, y compris le Travail de Bachelor. Les cours peuvent avoir lieu du lundi au vendredi, entre 8 h 30 et 18 h. En moyenne, il faut compter environ 35 à 40 périodes d’enseignement de 45 minutes par semaine pendant les 16 semaines de cours du semestre, auxquelles s’ajoutent le travail personnel, les projets et les révisions.</p>
                                <p>Vous trouverez votre horaire personnalisé, <strong>début septembre</strong> uniquement, sous le lien: <a href="https://gaps.heig-vd.ch/consultation/horaires">https://gaps.heig-vd.ch/consultation/horaires</a>. Si l’horaire ne s’affiche pas, sélectionner « S1 26-27 ».</p>
                            </>
                        ),
                    ],
                    [
                        isComemPt,
                        always(
                            <>
                                <p>La formation à plein temps se déroule selon les modalités suivantes :</p>
                                <ul>
                                    <li>6 semestres, y compris le travail de Bachelor.</li>
                                    <li>16 semaines de cours par semestre, auxquelles s'ajoutent le travail personnel, les projets et les révisions.</li>
                                    <li>32 périodes d'enseignement en classe par semaine.</li>
                                    <li>4 jours de cours (lundi à jeudi), le plus souvent de 8h30 à 18 h.</li>
                                    <li>Le vendredi est généralement consacré au travail à la maison (il y a des exceptions : cours blocs notamment).</li>
                                    <li>10 workshops multidisciplinaires dont 2 longs projets d'intégration en bloc de 3 et 4 semaines.</li>
                                </ul>
                                <p>Vous trouverez votre horaire personnalisé, début septembre uniquement, sous le lien: <a href="https://gaps.heig-vd.ch/consultation/horaires" target="_blank">https://gaps.heig-vd.ch/consultation/horaires</a>. Si l’horaire ne s’affiche pas, sélectionner « S1 26-27 ».</p>
                            </>
                        ),
                    ],
                    [
                        isComemEeTp,
                        always(
                            <>
                                <p>La formation en emploi et pour le PiBS se déroule selon les modalités suivantes :</p>
                                <ul>
                                    <li>8 semestres, y compris le travail de Bachelor.</li>
                                    <li>16 semaines de cours par semestre, auxquelles s'ajoutent le travail personnel, les projets et les révisions.</li>
                                    <li>Formation de 3 jours par semaine pendant 4 ans, le plus souvent de 8h30 à 16h15 (les jours de cours varient d’une année à l’autre).</li>
                                    <li>10 workshops multidisciplinaires dont 2 longs projets d'intégration en bloc de 3 et 4 semaines.</li>
                                </ul>
                                <p>Vous trouverez votre horaire personnalisé, début septembre uniquement, sous le lien: <a href="https://gaps.heig-vd.ch/consultation/horaires" target="_blank">https://gaps.heig-vd.ch/consultation/horaires</a>. Si l’horaire ne s’affiche pas, sélectionner « S1 26-27 ».</p>
                            </>
                        ),
                    ],
                    [
                        isTicEeTp,
                        always(
                            <>
                                <p>Une formation suivie en mode <strong>en emploi</strong> ou à <strong>temps partiel</strong> correspond à une charge de travail d’environ <strong>60 % à 70 %</strong>, selon le nombre de crédits ECTS pouvant être validés dans le cadre de l’activité en entreprise pour les étudiants en emploi.</p>
                                <p>La formation se déroule sur <strong>8 semestres de cours</strong>, y compris le Travail de Bachelor.</p>
                                <p>Les cours sont généralement concentrés sur <strong>2,5 à 3 jours par semaine</strong>, entre <strong>8 h 30 et 18 h</strong>. Pour la 1re année, les jours de cours prévus sont les <strong>lundi, mardi et vendredi</strong>. Ces jours peuvent toutefois changer d’un semestre à l’autre, en fonction de l’organisation de l’horaire.</p>
                                <p>Cette organisation permet en principe de maintenir une activité professionnelle à 50 % durant les semestres de cours.</p>
                                <p>Vous trouverez votre horaire personnalisé, début septembre uniquement, sous le lien: <a href="https://gaps.heig-vd.ch/consultation/horaires">https://gaps.heig-vd.ch/consultation/horaires</a>. Si l’horaire ne s’affiche pas, sélectionner « S1 26-27 ».</p>
                            </>
                        ),
                    ],
                    [
                        T,
                        always(
                            <>
                                <p>La présence aux cours est obligatoire.</p>
                                <p>
                                    Vous trouverez votre horaire personnalisé, <strong>début septembre</strong> uniquement, sous le lien:{' '}
                                    <a
                                        href="https://gaps.heig-vd.ch/consultation/horaires/"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        https://gaps.heig-vd.ch/consultation/horaires
                                    </a>
                                    . Si l’horaire ne s’affiche pas,
                                    sélectionner « S1 26-27 ».
                                </p>
                                <p>Pour les <strong>étudiant·es à temps partiel et en emploi</strong>, Les cours ont lieu sur deux après-midis et soirées et une journée complète, soit, pour la 1ère année, le lundi et le mardi de 13h15 à 21h35 et le jeudi de 8h30 à 12h00 et de 13h15 à 18h05. Puis, dès la 2e année, les jours de cours peuvent changer à chaque semestre.</p>
                            </>
                        ),
                    ],
                ])
            )}
        </div>
    )
}
